<template>
  <VaNavbar class="app-layout-navbar py-2 px-0">
    <template #left>
      <div class="left">
        <Transition v-if="isMobile && !isGuard" name="icon-fade" mode="out-in">
          <VaIcon
            color="primary"
            :name="isSidebarMinimized ? 'menu' : 'close'"
            size="24px"
            style="margin-top: 3px"
            @click="isSidebarMinimized = !isSidebarMinimized"
          />
        </Transition>
        <RouterLink to="/" aria-label="Visit home page">
          <VuesticLogo :height="40" icon-only />
        </RouterLink>
        <span class="brand-title">{{ brandTitle }}</span>
      </div>
    </template>
    <template #right>
      <AppNavbarActions class="app-navbar__actions" :is-mobile="isMobile" :is-guard="isGuard" />
    </template>
  </VaNavbar>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '../../stores/global-store'
import { useSettingsStore } from '../../stores/settings'
import AppNavbarActions from './components/AppNavbarActions.vue'
import VuesticLogo from '../VuesticLogo.vue'
import { APP_NAME } from '../../config/brand'

defineProps({
  isMobile: { type: Boolean, default: false },
  isGuard: { type: Boolean, default: false },
})

const GlobalStore = useGlobalStore()
const settingsStore = useSettingsStore()

const { isSidebarMinimized } = storeToRefs(GlobalStore)

const brandTitle = computed(() => {
  const subdivision = settingsStore.data?.subdivision?.trim()
  return subdivision ? `${subdivision} - ${APP_NAME}` : APP_NAME
})
</script>

<style lang="scss" scoped>
.va-navbar {
  z-index: 2;

  @media screen and (max-width: 950px) {
    .left {
      width: 100%;
    }

    .app-navbar__actions {
      display: flex;
      justify-content: space-between;
    }
  }
}

.left {
  display: flex;
  align-items: center;
  margin-left: 1rem;

  & > * {
    margin-right: 1rem;
  }

  & > *:last-child {
    margin-right: 0;
  }
}

.brand-title {
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: 0.03em;
  color: var(--va-text-primary);
}

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: transform 0.5s ease;
}

.icon-fade-enter,
.icon-fade-leave-to {
  transform: scale(0.5);
}
</style>
